// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamManager_teamManager__gZ0cV {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}
.TeamManager_teamManager__gZ0cV h2 {
  margin-bottom: 20px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_addButton__XW59y {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_addButton__XW59y:hover {
  background-color: #0056b3;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q {
  list-style: none;
  padding: 0;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #f9f9f9;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamContent__NzxHn {
  flex: 1 1;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamContent__NzxHn h3 {
  margin: 0;
  font-size: 1.2em;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamContent__NzxHn p {
  margin: 5px 0 0;
  color: #555;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O {
  display: flex;
  gap: 10px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2em;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O button.TeamManager_editButton__wXY9n {
  color: #007bff;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O button.TeamManager_editButton__wXY9n:hover {
  color: #0056b3;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O button.TeamManager_deleteButton__N2-jY {
  color: #ff0000;
}
.TeamManager_teamManager__gZ0cV .TeamManager_teamList__8jO0q .TeamManager_teamItem__Q7BuN .TeamManager_teamActions__f0y-O button.TeamManager_deleteButton__N2-jY:hover {
  color: #cc0000;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr h3 {
  margin-bottom: 20px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_formGroup__wlrVp {
  margin-bottom: 15px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_formGroup__wlrVp label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_formGroup__wlrVp .TeamManager_inputField__HIV-N, .TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_formGroup__wlrVp .TeamManager_multiSelect__yb5RA {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  background-color: white;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_formGroup__wlrVp .TeamManager_multiSelect__yb5RA {
  height: 120px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_error__vBEsx {
  color: #ff0000;
  margin-bottom: 10px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ button.TeamManager_saveButton__umddS {
  background-color: #007bff;
  color: white;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ button.TeamManager_saveButton__umddS:hover {
  background-color: #0056b3;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ button.TeamManager_cancelButton__vfxOl {
  background-color: #ccc;
}
.TeamManager_teamManager__gZ0cV .TeamManager_modalOverlay__iPgvS .TeamManager_modalContent__PbEJr .TeamManager_modalActions__YbKWQ button.TeamManager_cancelButton__vfxOl:hover {
  background-color: #bbb;
}
@media (max-width: 768px) {
  .TeamManager_teamManager__gZ0cV {
    padding: 10px;
  }
  .TeamManager_teamManager__gZ0cV .TeamManager_modalContent__PbEJr {
    width: 100%;
    max-width: 90%;
  }
}

.TeamManager_selectField__qRray {
  margin-bottom: 15px;
}
.TeamManager_selectField__qRray .TeamManager_react-select__control__V327N {
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 38px;
}
.TeamManager_selectField__qRray .TeamManager_react-select__multi-value__TwIDn {
  background-color: #007bff;
  color: white;
  border-radius: 4px;
}
.TeamManager_selectField__qRray .TeamManager_react-select__multi-value__label__LWF\\+3 {
  color: white;
}
.TeamManager_selectField__qRray .TeamManager_react-select__multi-value__remove__nGAc4 {
  color: white;
}
.TeamManager_selectField__qRray .TeamManager_react-select__multi-value__remove__nGAc4:hover {
  background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/Pages/TeamManager/TeamManager.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAIE;EACE,gBAAA;EACA,UAAA;AAFJ;AAII;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAFN;AAIM;EACE,SAAA;AAFR;AAIQ;EACE,SAAA;EACA,gBAAA;AAFV;AAKQ;EACE,eAAA;EACA,WAAA;AAHV;AAOM;EACE,aAAA;EACA,SAAA;AALR;AAOQ;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AALV;AAOU;EACE,cAAA;AALZ;AAOY;EACE,cAAA;AALd;AASU;EACE,cAAA;AAPZ;AASY;EACE,cAAA;AAPd;AAeE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AAbN;AAeM;EACE,mBAAA;AAbR;AAgBM;EACE,mBAAA;AAdR;AAgBQ;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAdV;AAiBQ;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AAfV;AAkBQ;EACE,aAAA;AAhBV;AAoBM;EACE,cAAA;EACA,mBAAA;AAlBR;AAqBM;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAnBR;AAqBQ;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnBV;AAqBU;EACE,yBAAA;EACA,YAAA;AAnBZ;AAqBY;EACE,yBAAA;AAnBd;AAuBU;EACE,sBAAA;AArBZ;AAuBY;EACE,sBAAA;AArBd;AA6BE;EAnKF;IAoKI,aAAA;EA1BF;EA4BE;IACE,WAAA;IACA,cAAA;EA1BJ;AACF;;AA6BA;EACE,mBAAA;AA1BF;AA4BE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AA1BJ;AA6BE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;AA3BJ;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,YAAA;AA7BJ;AA8BI;EACE,yBAAA;AA5BN","sourcesContent":[".teamManager {\r\n  padding: 20px;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n\r\n  h2 {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .addButton {\r\n    padding: 10px 15px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-bottom: 20px;\r\n\r\n    &:hover {\r\n      background-color: #0056b3;\r\n    }\r\n  }\r\n\r\n  .teamList {\r\n    list-style: none;\r\n    padding: 0;\r\n\r\n    .teamItem {\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n      padding: 15px;\r\n      border: 1px solid #ddd;\r\n      border-radius: 8px;\r\n      margin-bottom: 10px;\r\n      background-color: #f9f9f9;\r\n\r\n      .teamContent {\r\n        flex: 1;\r\n\r\n        h3 {\r\n          margin: 0;\r\n          font-size: 1.2em;\r\n        }\r\n\r\n        p {\r\n          margin: 5px 0 0;\r\n          color: #555;\r\n        }\r\n      }\r\n\r\n      .teamActions {\r\n        display: flex;\r\n        gap: 10px;\r\n\r\n        button {\r\n          background: none;\r\n          border: none;\r\n          cursor: pointer;\r\n          font-size: 1.2em;\r\n\r\n          &.editButton {\r\n            color: #007bff;\r\n\r\n            &:hover {\r\n              color: #0056b3;\r\n            }\r\n          }\r\n\r\n          &.deleteButton {\r\n            color: #ff0000;\r\n\r\n            &:hover {\r\n              color: #cc0000;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .modalOverlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    .modalContent {\r\n      background-color: white;\r\n      padding: 20px;\r\n      border-radius: 8px;\r\n      width: 90%;\r\n      max-width: 500px;\r\n\r\n      h3 {\r\n        margin-bottom: 20px;\r\n      }\r\n\r\n      .formGroup {\r\n        margin-bottom: 15px;\r\n\r\n        label {\r\n          display: block;\r\n          margin-bottom: 5px;\r\n          font-weight: bold;\r\n        }\r\n\r\n        .inputField, .multiSelect {\r\n          width: 100%;\r\n          padding: 10px;\r\n          border: 1px solid #ccc;\r\n          border-radius: 4px;\r\n          font-size: 1em;\r\n          background-color: white;\r\n        }\r\n\r\n        .multiSelect {\r\n          height: 120px;\r\n        }\r\n      }\r\n\r\n      .error {\r\n        color: #ff0000;\r\n        margin-bottom: 10px;\r\n      }\r\n\r\n      .modalActions {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        gap: 10px;\r\n\r\n        button {\r\n          padding: 10px 15px;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n\r\n          &.saveButton {\r\n            background-color: #007bff;\r\n            color: white;\r\n\r\n            &:hover {\r\n              background-color: #0056b3;\r\n            }\r\n          }\r\n\r\n          &.cancelButton {\r\n            background-color: #ccc;\r\n\r\n            &:hover {\r\n              background-color: #bbb;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 10px;\r\n\r\n    .modalContent {\r\n      width: 100%;\r\n      max-width: 90%;\r\n    }\r\n  }\r\n}\r\n.selectField {\r\n  margin-bottom: 15px;\r\n\r\n  .react-select__control {\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    min-height: 38px;\r\n  }\r\n\r\n  .react-select__multi-value {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .react-select__multi-value__label {\r\n    color: white;\r\n  }\r\n\r\n  .react-select__multi-value__remove {\r\n    color: white;\r\n    &:hover {\r\n      background-color: #0056b3;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamManager": `TeamManager_teamManager__gZ0cV`,
	"addButton": `TeamManager_addButton__XW59y`,
	"teamList": `TeamManager_teamList__8jO0q`,
	"teamItem": `TeamManager_teamItem__Q7BuN`,
	"teamContent": `TeamManager_teamContent__NzxHn`,
	"teamActions": `TeamManager_teamActions__f0y-O`,
	"editButton": `TeamManager_editButton__wXY9n`,
	"deleteButton": `TeamManager_deleteButton__N2-jY`,
	"modalOverlay": `TeamManager_modalOverlay__iPgvS`,
	"modalContent": `TeamManager_modalContent__PbEJr`,
	"formGroup": `TeamManager_formGroup__wlrVp`,
	"inputField": `TeamManager_inputField__HIV-N`,
	"multiSelect": `TeamManager_multiSelect__yb5RA`,
	"error": `TeamManager_error__vBEsx`,
	"modalActions": `TeamManager_modalActions__YbKWQ`,
	"saveButton": `TeamManager_saveButton__umddS`,
	"cancelButton": `TeamManager_cancelButton__vfxOl`,
	"selectField": `TeamManager_selectField__qRray`,
	"react-select__control": `TeamManager_react-select__control__V327N`,
	"react-select__multi-value": `TeamManager_react-select__multi-value__TwIDn`,
	"react-select__multi-value__label": `TeamManager_react-select__multi-value__label__LWF+3`,
	"react-select__multi-value__remove": `TeamManager_react-select__multi-value__remove__nGAc4`
};
export default ___CSS_LOADER_EXPORT___;
